// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"324":"348e8ed8","904":"c34aaefb"}[chunkId] + ".chunk.js";
};